
import {createSlice} from "@reduxjs/toolkit";


export const profileSlice = createSlice({
    name: 'profileSlc',
    initialState: {value: {id: null, externalId: null, firstName: null, lastName: null,
            ssn: null, dateOfBirth: null, dateOfDeath: null, companyName: null,
            fein: null,dateOfDissolution:null,streetAddress:null,city:null,
            stateProvince: null, postalCode: null, country: null, payStatus: null, status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            profileDrawerState: false, profileDrawerMode: null, profileGridRefresh: false
        }},
    reducers:
{
    changeProfile: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeProfile } = profileSlice.actions;

export default  profileSlice.reducer ;

